const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "cpa",
  },
  "kdmytax.ca": {
    name: "Kdmytax",
    domainName: "kdmytax.ca",
    logo: "/assets/logo/logo.png",
    authLogo: "/assets/logo/auth-logo.png",
    favicon: "/assets/logo/favicon.ico",
    intractName: "KDMYTAX",
    intractEmail: "info@kdmytax.ca",
    firmType: "cpa",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
